import cn from 'clsx'
import { Markup as InterweaveMarkup, type MarkupProps, type Node } from 'interweave'
import { polyfill } from 'interweave-ssr'

import { HyperLink } from '../hyper-link/hyper-link'

import css from './markup.module.css'

import type { ReactNode } from 'react'

polyfill()

function transform(node: HTMLElement, children: Node[]): React.ReactNode {
    if (node.tagName === 'a') {
        const href = node.getAttribute('href') || undefined
        const target = node.getAttribute('target') || undefined
        const rel = node.getAttribute('rel') || undefined
        return (
            <HyperLink href={href} target={target} rel={rel}>
                {children as ReactNode}
            </HyperLink>
        )
    }
}

export function Markup({ className, ...props }: MarkupProps) {
    return (
        <InterweaveMarkup className={cn(css.markup, className)} transform={transform} {...props} />
    )
}
